export const SET_DESCRIPTION_ERROR = 'SET_DESCRIPTION_ERROR';